<div class="col-12 col-lg-12 md-12" *ngIf="componentsGroup.components.length >= 2">
  <div class="cdc-label" *ngIf="componentsGroup.title">
    <span class="text-new-lines" *ngIf="componentsGroup.title">
      {{ componentsGroup.title }}
    </span>
    <mat-icon class="component-title-help" *ngIf="componentsGroup.helpText && componentsGroup.helpText.length > 0" matTooltipClass="multiline-tooltip" matTooltip="{{componentsGroup.helpText}}" [matTooltipPosition]="'right'">help</mat-icon>
  </div>

  <div *ngIf="componentsGroup.description" class="cdc-label-description text-new-lines">
    {{ componentsGroup.description }}
  </div>
</div>
<div *ngFor="let dataGroup of customersDataGrouped | keyvalue: sortGroupsWithMainIndicator; let x = index; trackBy: trackDataGroupByKey" class="col-12 col-lg-12 md-12 d-flex flex-row">

  <div class="w-100 d-flex flex-wrap">
    <div *ngFor="let dataComponent of dataGroup.value; let i = index" [ngClass]="getComponentSize(dataComponent.component.id)" class="p-1">
      <div *ngIf="verifyConditions(dataComponent.component.id, dataGroup, dataComponent)" class="d-flex flex-row flex-wrap align-items-start">
        <app-component-form
          [ngClass]="{
            'component-with-actions-group': (canRemoveGroup() || dataGroupHasNotMainActivityPrestations(dataGroup)),
            'col-12 col-lg-12 col-md-12': !(canRemoveGroup() || dataGroupHasNotMainActivityPrestations(dataGroup))
          }"
          [customerPage]="customerPage"
          [userRole]="userRole"
          [customerPageData]="dataComponent"
          [component]="getComponentById(dataComponent.component.id)!"
          [block]="block"
          [customer]="customer"
          [customerId]="dataComponent.customer.id"
          [dataIndex]="(componentsGroup.multipleConfig!.haveIndexTitles && i === 0) ? (x + 1) : undefined"
          [index]="i"
          [dataGroupCustomerPageData]="dataGroup"
          [groupCustomerPageData]="customerPageDataGroup"
          [pageCustomerPageData]="customersData"
          [totalDataGroups]="totalDataGroups"
          [offerStatus]="offerStatus"
          [refBusinessLists]="refBusinessLists"
          [fullConnectionsDefinitions]="fullConnectionsDefinitions"
          (customersDataChange)="handleCustomerPageDatasChange($event)"
          (scrollToSchedule)="scrollToSchedule($event)"
          (fieldContainerClick)="onComponentFormClick($event)"
          (tooltipPosition)="onTooltipPositionChanged($event)"
          (recalculateTooltipsPosition)="recalculateTooltipsPositionEmit()"
          (closeAllTooltipsExceptCurrent)="closeAllTooltipsExceptCurrentEmit($event)"
          (activityChanged)="onActivityChanged()"
          [isSummary]="isSummary"
          [isConditionedClosed]="false"
          [isCurrentBlock]="isCurrentBlock"
          [activitiesAlreadySelected]="activitiesAlreadySelected">
        </app-component-form>

        <div *ngIf="(i == 0 && canRemoveGroup()) || (dataComponent.component.type == ComponentType.ACTIVITY_PRESTATIONS && !dataComponentIsMainActivityPrestations(dataComponent))"
          class="actions-group">

          <button mat-icon-button
            *ngIf="dataComponent.component.type == ComponentType.ACTIVITY_PRESTATIONS && !dataComponentIsMainActivityPrestations(dataComponent)"
            (click)="onUpdateActivityPrestationMainIndicator(dataGroup)"
            matTooltip="{{ 'Set as main' | translate }}"
            matTooltipPosition="right"
          >
            <mat-icon
              *ngIf="dataComponent.component.type == ComponentType.ACTIVITY_PRESTATIONS && !dataComponentIsMainActivityPrestations(dataComponent)"
              (click)="onUpdateActivityPrestationMainIndicator(dataGroup)"
              matTooltip="{{ 'Set as main' | translate }}"
              matTooltipPosition="right">arrow_upward</mat-icon>
          </button>

          <div [matTooltip]="dataComponentIsMainActivityPrestations(dataComponent)
                ? ('Set another activity as main before deleting this one' | translate)
                : ''"
                matTooltipPosition="right">
            <button mat-icon-button
              *ngIf="i == 0 && canRemoveGroup()"
              [disabled]="dataComponentIsMainActivityPrestations(dataComponent)"
              (click)="removeDataGroup(dataGroup)"
              [matTooltip]="groupHasActivityPrestations
                ? ('Remove activity' | translate)
                : ('Remove answer' | translate)"
              matTooltipPosition="right"
            >
              <mat-icon>remove_circle</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<a *ngIf="canAddGroup()" (click)="addDataGroup()" class="add-group cdc-add-answer">
  <mat-icon
    [matTooltip]="componentsGroup.multipleConfig!.textBtnMultiple ?
    '' : (groupHasActivityPrestations ?
      ('Add activity' | translate) : ('Add answer' | translate))"
  >add_circle</mat-icon> {{componentsGroup.multipleConfig!.textBtnMultiple}}
</a>
